import { cn } from '@/shadcn-ui/utils';
import { useScroll, useMotionValueEvent, motion } from 'motion/react';
import { useState } from 'react';
import Banner, { BannerVariants } from './banner';

interface PageBannerProps {
  children: React.ReactNode;
  isSticky?: boolean;
  variant?: BannerVariants;
  ref?: React.RefObject<HTMLDivElement | null>;
}

const yAxisLimit = 72;

export default function PageBanner({
  children,
  isSticky,
  variant,
  ref,
}: PageBannerProps) {
  const bannerVariant = variant ?? 'blue-bg-no-spacer';
  const [isDockedAtTop, setIsDockedAtTop] = useState(true);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, 'change', (latest) => {
    if (latest < yAxisLimit) {
      setIsDockedAtTop(true);
    } else {
      setIsDockedAtTop(false);
    }
  });

  if (!isSticky) {
    return (
      <div className="w-full">
        <Banner variant={bannerVariant} ref={ref}>
          {children}
        </Banner>
      </div>
    );
  }

  return (
    <motion.div
      className={cn('w-full', {
        'fixed left-0 top-0 z-10': !isDockedAtTop && isSticky,
        'hidden': isDockedAtTop && isSticky,
      })}
      initial={{ opacity: 0, y: -yAxisLimit }}
      animate={{
        opacity: !isDockedAtTop && isSticky ? 1 : 0,
        y: !isDockedAtTop && isSticky ? 0 : -yAxisLimit,
      }}
      transition={{
        duration: 0.15,
        ease: 'easeIn',
      }}
    >
      <Banner variant={bannerVariant} ref={ref}>
        {children}
      </Banner>
    </motion.div>
  );
}
